import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"fontPoppins\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollButton"] */ "/app/src/components/footer/scroll-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/header/user-menu/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/providers/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/providers/user-provider.tsx");
